import Vue from "vue";
import moment from "moment";
import * as types from "./mutation-types";

const actions = {
  setPageLoaded({ commit }, data) {
    commit(types.SET_PAGE_LOADED, { key: data.key, value: data.value });
  },

  setPageLoading({ commit }, data) {
    commit(types.SET_PAGE_LOADING, { key: data.key, value: data.value });
  },

  reloadChallengePages({ dispatch, state }) {
    Object.keys(state).forEach(key => {
      const regex = /Challenge\d+-loaded/;
      const page = key.split("-")[0];

      if (regex.test(key)) {
        dispatch("setPageLoaded", { key: page, value: false });
      }
    });
  },

  async fetchAllPageMyDashboard({ dispatch, getters, rootGetters }, member) {
    // send off requests for data that is not cached
    // cached components/logic tagged with [auth.user optimism]

    // NOTE: fetchActivitiies moved to when: modal open, or after journals loaded
    // dispatch("members/fetchActivities", member.programId, { root: true }),
    dispatch(
      "members/fetchMakeAnEntryJournalByDate",
      {
        memberId: member.id,
        date: moment(new Date()).format("YYYY-MM-DD")
      },
      { root: true }
    );
    Promise.all([
      dispatch(
        "members/fetchMemberStepData",
        { memberId: member.id },
        { root: true }
      ),
      dispatch(
        "members/fetchJournals",
        {
          memberId: member.id,
          isProfile: false,
          photosOnly: false,
          friends: false,
          page: null,
          resetList: true
        },
        { root: true }
      ),
      dispatch("members/fetchFriends", { memberId: member.id }, { root: true })
    ]);

    // TEAMS STUFF
    if (
      rootGetters["program/isTeamsFeatureOn"] &&
      (!getters.isPageLoaded("Teams") || !getters.isPageLoaded("Challenges"))
    ) {
      dispatch(
        "program/fetchProgramTeams",
        {
          programId: member.programId
        },
        { root: true }
      ); // needed for join button
      dispatch(
        "members/fetchMemberTeamInvites", // needed for join button
        { memberId: member.id },
        {
          root: true
        }
      );
      // needed for join button
      dispatch("members/fetchMemberTeams", member.id, {
        root: true
      });
      dispatch("members/fetchTeamsMemberIsAdmin", member.id, { root: true });
    }

    await Promise.all([
      // below also fetched for Challenges page
      dispatch("members/fetchRequestedJoinMessages", member.id, { root: true }),
      dispatch("members/fetchChallenges", member.id, { root: true }),
      dispatch(
        "members/fetchChallengeInvites",
        {
          memberId: member.id,
          recipient: 1
        },
        { root: true }
      ),
      dispatch("program/fetchFeaturedChallenge", member.programId, {
        root: true
      }),
      dispatch(
        "members/fetchMemberNotice",
        { memberId: member.id },
        {
          root: true
        }
      )
    ]);
  },

  async fetchAllPageSitewide({ dispatch }, programId) {
    await Promise.all([
      dispatch("program/fetchStepData", programId, { root: true }),
      dispatch("program/fetchLeaderboardData", programId, { root: true }),
      dispatch("program/fetchAggregateData", programId, { root: true })
    ]);
    dispatch("program/fetchJournals", { programId }, { root: true });
  },

  async fetchAllPageChallenges({ dispatch, getters, rootGetters }, member) {
    await dispatch(
      "program/fetchChallenges",
      {
        programId: member.programId
      },
      { root: true }
    );

    // below also fetched for MyDashboard
    if (!getters.isPageLoaded("MyDashboard")) {
      await Promise.all([
        dispatch("members/fetchRequestedJoinMessages", member.id, {
          root: true
        }),
        dispatch("members/fetchChallenges", member.id, { root: true }),
        dispatch(
          "members/fetchChallengeInvites",
          {
            memberId: member.id,
            recipient: 1
          },
          { root: true }
        ),
        dispatch("program/fetchFeaturedChallenge", member.programId, {
          root: true
        }),
        dispatch("members/fetchTeamsMemberIsAdmin", member.id, { root: true })
      ]);
      dispatch(
        "members/fetchArchivedChallenges",
        { memberId: member.id },
        { root: true }
      );
    }

    // TEAMS STUFF
    if (
      rootGetters["program/isTeamsFeatureOn"] &&
      (!getters.isPageLoaded("MyDashboard") || !getters.isPageLoaded("Teams"))
    ) {
      dispatch(
        "program/fetchProgramTeams",
        {
          programId: member.programId
        },
        { root: true }
      ); // needed for join button
      dispatch(
        "members/fetchMemberTeamInvites", // needed for join button
        { memberId: member.id },
        {
          root: true
        }
      );
      // needed for join button
      dispatch("members/fetchMemberTeams", member.id, {
        root: true
      });
    }

    dispatch(
      "program/fetchProgramMaps",
      {},
      {
        root: true
      }
    );
  },

  async fetchAllPageFriends({ dispatch }, memberId) {
    await Promise.all([
      // fetchFriends calls a cached endpoint in the API
      dispatch("members/fetchFriends", { memberId }, { root: true }),
      dispatch("members/fetchFriendsInvited", memberId, { root: true }),
      dispatch("members/fetchFriendsRequesting", memberId, { root: true })
    ]);
  },

  async fetchAllPageTeams({ dispatch, getters }) {
    const member = Vue.auth.user();

    // also fetched for MyDashboard and Challenges pages
    if (
      !getters.isPageLoaded("MyDashboard") ||
      !getters.isPageLoaded("Challenges")
    ) {
      await Promise.all([
        dispatch("program/fetchFeaturedChallenge", member.programId, {
          root: true
        }),
        dispatch(
          "program/fetchChallenges",
          {
            programId: member.programId
          },
          { root: true }
        ),
        dispatch(
          "program/fetchProgramTeams",
          {
            programId: member.programId
          },
          { root: true }
        ),
        dispatch(
          "members/fetchMemberTeamInvites",
          { memberId: member.id },
          {
            root: true
          }
        ),
        dispatch("members/fetchMemberTeams", member.id, { root: true }),
        dispatch("members/fetchTeamsMemberIsAdmin", member.id, { root: true })
      ]);
    }
  }
};

export default actions;
